import styled from '@emotion/styled';
import DropdownListBox from '../common/DropdownListBox';

export const DropdownCheckboxListWrapper = styled.div`
  position: relative;
`;

export const StyledDropdownListBox = styled(DropdownListBox)`
  min-width: 280px;
  width: unset;
`;
